exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.diff-row-added td[data-v-52abae0a] {\n    background-color: rgba(40, 167, 69, 0.18);\n}\n.diff-row-removed td[data-v-52abae0a] {\n    background-color: rgba(220, 53, 69, 0.18);\n}\n.diff-row-changed td[data-v-52abae0a] {\n    background-color: rgba(255, 193, 7, 0.18);\n}\n.diff-row-added td[data-v-52abae0a]:first-child {\n    box-shadow: inset 3px 0 0 #28a745;\n}\n.diff-row-removed td[data-v-52abae0a]:first-child {\n    box-shadow: inset 3px 0 0 #dc3545;\n}\n.diff-row-changed td[data-v-52abae0a]:first-child {\n    box-shadow: inset 3px 0 0 #ffc107;\n}\n", ""]);

// exports
